import { PieceworkItems } from './../models/piecework/PieceworkItems'
import { msToHours, subtractTimeToDate } from '@/utils'
import { PieceworkItemsInput, WorkDescriptionPieceworkInput } from '@/models/piecework'

export const getTotalWorkDescriptions = (items: WorkDescriptionPieceworkInput[]) => {
  return items.reduce((acc, current) => acc + current.amount_total, 0)
}

// eslint-disable-next-line
export const getTotalHoursPiecework = (items: any[]) => {
  return items.filter((item: PieceworkItems|PieceworkItemsInput) => item.work_modality === 'D').reduce((acc: number, current: PieceworkItems|PieceworkItemsInput) => acc + Number(current.total_hours), 0)
}

export const getTotalWorking = (item: PieceworkItemsInput) => {
  const dateTimeIn = subtractTimeToDate(String(item.time_in))
  let dateTimeOut = subtractTimeToDate(String(item.time_out))
  let total = 0
  if (dateTimeOut && dateTimeIn) {
    if (!(dateTimeOut >= dateTimeIn)) {
      dateTimeOut = subtractTimeToDate(String(item.time_out), true)
    }
    // @ts-ignore
    total = msToHours(dateTimeOut - dateTimeIn)
  }
  return Number(total.toFixed(2))
}
